let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hRE4a")).then(() => parcelRequire('d4y8J'));